import { Proposal, RequestForExpertProposal, RequestForStartupProposal } from "./schema";

export type Proposaly = Proposal | RequestForStartupProposal | RequestForExpertProposal;

export enum ProposalyType {
  PROPOSAL = "Proposal",
  REQUEST_FOR_STARTUP_PROPOSAL = "RequestForStartupProposal",
  REQUEST_FOR_EXPERT_PROPOSAL = "RequestForExpertProposal",
}
